import React, { useState, useMemo } from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { Card, Form } from 'react-bootstrap'

interface ClickDataTableProps<T> {
    title: string
    columns: TableColumn<T>[]
    data: T[]
    height?:string
    id:string
}

export function ClickDataTable<T extends { [key: string]: any }>({
    title,
    columns,
    data,
    height,
    id
}: ClickDataTableProps<T>) {
    const [filterText, setFilterText] = useState('')

    const filteredData = useMemo(() => {
        if (!filterText) return data
        return data.filter(row =>
            Object.values(row)
                .join(' ')
                .toLowerCase()
                .includes(filterText.toLowerCase())
        )
    }, [data, filterText])

    return (
    <div style={{  }}>
            <Card className="mb-3 shadow-sm">
                <Card.Body>
                    <h5>{title}</h5>
                    <div style={{ maxWidth: '300px', marginBottom: '0.5rem' }}>
                        <Form.Group controlId={`${title}-search`}>
                            <Form.Control
                                type="text"
                                placeholder="Search..."
                                value={filterText}
                                onChange={e => setFilterText(e.target.value)}
                                size='sm'
                            />
                        </Form.Group>
                    </div>
                    {/* <div style={{ maxHeight: height || '300px', height: height || '300px', overflowY: 'auto' }}> */}
                        <DataTable
                            columns={columns}
                            data={filteredData}
                            defaultSortFieldId={id}
                            defaultSortAsc={false}
                            dense
                            responsive
                            fixedHeader
                            pagination
                            paginationPerPage={50}
                            paginationRowsPerPageOptions={[50, 100, 200, 500]} 
                            fixedHeaderScrollHeight={height || '300px'}
                            
                            customStyles={{
                                table:{style:{width:'400px', minWidth: '100%'}},
                                // table: {
                                //     style: {
                                //             overflow: 'auto !important',
                                //             width:'90%',
                                //     }
                                // },
                                cells: {
                                    style: {
                                        borderBottom: '1px solid rgba(0,0,0,.12)',
                                    },
                                    
                                },
                                rows: {
                                    style: {
                                        borderBottom: 'none !important',
                                    },
                                },
                                headRow: {
                                    style: {
                                        borderBottom: 'none !important',
                                    },
                                },
                                headCells: {
                                    style: {
                                        borderBottom: '1px solid rgba(0,0,0,.12)',
                                        backgroundColor:'#fff'
                                    },
                                }
                            }}
                        />
                    {/* </div> */}
                </Card.Body>
            </Card>
        </div>
    )
}
